
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { Pagination } from 'element-ui';
import { IBTNCONF } from '@/types/base.d';
import { IOrgForm } from '@/types/org.d';
import bModal from './components/bModal.vue';
import tableMixin from './tableMixin';

@Component({
  components: {
    Pagination,
    bModal,
  },
})
export default class ManageView extends Mixins(tableMixin) {
  private actionBtns: Array<IBTNCONF> = [{
    title: '新增',
    name: '/question/homework:add',
    icon: 'plus',
    callback: this.handleAddForm,
    log: {
      name: '机构管理 - 新增',
      component: 'org/mange/components/bModal',
    },
  }];

  private visible: boolean = false;

  private title: string = '添加课后作业';

  private form: any = {};

  /**
   * @author liangyongmou
   * @desc 添加课后作业
   */
  handleAddForm() {
    this.title = '添加课后作业';
    this.visible = true;
  }

  /**
   * @author liangyongmou
   * @desc 编辑课后作业
   * @param { any } row 行数据
   */
  handleUpdateForm(row: any) {
    this.form = {
      questionType: row.questionType,
      knowledge: row.knowledge,
      courseType: row.courseType,
      difficulty: row.difficulty,
      content: row.content,
      answer: row.answer,
      pid: row.pid,
    };
    this.title = '编辑课后作业';
    this.visible = true;
  }

  @Watch('page', { immediate: false, deep: true })
  handlePageChange() {
    this.getData();
  }
}
